import React from 'react';
import { TextReplace } from 'src/shared/design-system/Utilities';
import styled from 'styled-components';
import { DEFAULT_ACCEPT, DROP_ZONE_TEXT, PHOTO_ACCEPT, PHOTO_VIDEO_SIZE } from './consts';
import { PhotoUpload } from './PhotoUpload';
import {
  MediaDropzone,
  Photo,
  PhotoContainer,
  UploadDropdownReplaceText1,
  UploadDropdownReplaceText2,
  UploadDropZoneContainer,
} from './styles';
import { MediaUploadProps } from './types';

const Uploader = styled(PhotoUpload)`
  & ${PhotoContainer} {
    box-sizing: border-box;
    max-width: 100% !important;
  }
  & ${Photo} {
    border: 0px !important;
    border-radius: 0px !important;
    max-width: 200% !important;
    max-height: 200% !important;
    object-fit: cover;
  }
`;

export const UploadDropZoneContent = (props: { enableVideoUpload: boolean }) => {
  const { enableVideoUpload } = props;
  return (
    <UploadDropZoneContainer>
      <TextReplace
        replaceText={[
          <UploadDropdownReplaceText1>{DROP_ZONE_TEXT.REPLACE_1}</UploadDropdownReplaceText1>,
          <UploadDropdownReplaceText2>{DROP_ZONE_TEXT.REPLACE_2}</UploadDropdownReplaceText2>,
        ]}
        text={enableVideoUpload ? DROP_ZONE_TEXT.DROP_ZONE : DROP_ZONE_TEXT.DROP_ZONE_NO_VIDEO}
      />
    </UploadDropZoneContainer>
  );
};

/**
 * Photo and Video selector with drag and drop functionality for uploading.
 * Component does not automatically upload photo. Use `onChange`
 * callback to get the processed image to upload to server.
 */
export const MediaUpload: React.FC<MediaUploadProps> = (props) => {
  const { accept, enableVideoUpload = true, photoSize = PHOTO_VIDEO_SIZE, placeholderContent, ...otherProps } = props;
  const fileAccept = accept || enableVideoUpload ? DEFAULT_ACCEPT : PHOTO_ACCEPT;
  return (
    <Uploader
      accept={fileAccept}
      photoSize={photoSize}
      {...otherProps}
      placeholderContent={
        placeholderContent ?? (
          <MediaDropzone>
            <UploadDropZoneContent enableVideoUpload={enableVideoUpload} />
          </MediaDropzone>
        )
      }
    />
  );
};

export { MediaDropzone };
